/**
 * A sheet (see /styleguide): a dialog headed as iOS's navigation bars, its
 * title between its actions (e.g. Clear and Done). On phones it fills the
 * screen, sliding up from the bottom (in the app, over the tab bar too).
 */
import * as preact from "preact";

import * as modalController from "modalController";
import Button from "ui/Button";

export interface SheetAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface Props {
  title: string;
  /** On its left, e.g. Cancel or Clear */
  leading?: SheetAction;
  /** On its right: Done, by default, closing it */
  trailing?: SheetAction;
  children: preact.ComponentChildren;
}

export default class Sheet extends preact.Component<Props> {
  private renderAction(action: SheetAction | undefined) {
    return action ? (
      <Button kind="plain" disabled={action.disabled} onClick={action.onClick}>
        {action.label}
      </Button>
    ) : null;
  }

  render() {
    const trailing = this.props.trailing ?? {
      label: "Done",
      onClick: () => modalController.cancel(),
    };
    return (
      <div class="sheet">
        <header class="sheetHeader">
          <span class="sheetLeading">
            {this.renderAction(this.props.leading)}
          </span>
          <h2>{this.props.title}</h2>
          <span class="sheetTrailing">{this.renderAction(trailing)}</span>
        </header>
        <div class="sheetBody">{this.props.children}</div>
      </div>
    );
  }
}

/** Shows a sheet: on phones over the whole screen, elsewhere a dialog */
export const showSheet = (
  sheet: preact.ComponentChild,
  options: modalController.ModalOptions = {}
) => modalController.show(sheet, { closeButton: false, ...options });
